import { TextStyle, IDestroyOptions, Texture, Text, Sprite } from "pixi.js";
import { Sound } from "@pixi/sound";
import { DefaultButton } from "./DefaultButton";

export class DefaultButtonWithText extends DefaultButton {
    public constructor(texture: Texture, text: string, textStyle: TextStyle, pressSound?: Sound) {
        super(texture, pressSound);
        const buttonText = new Text(text, textStyle);
        buttonText.position.set(this.width * 0.5 - buttonText.width * 0.5, this.height * 0.5 - buttonText.height * 0.5);
        this.defaultView.addChild(buttonText);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}
